import {ElearningFilledSvg} from "./elearning-filled-svg.js";
import {ElearningSvg} from "./elearning-svg.js";
import {EmploymentEligibilitySvg} from "./employment-eligibility-svg.js";
import {EntriesSvg} from "./entries-svg.js";
import {EmployeeConsentSvg} from "./employee-consent-svg.js";
import {ExpandSvg} from "./expand-svg.js";
import {FeedbackSvg} from "./feedback-svg.js";
import {GeneralDocsSvg} from "./general-docs-svg.js";
import {FinalOutstandingSvg} from "./final-outstanding-svg.js";
import {GfeSvg} from "./gfe-svg.js";
import {ForecastingSvg} from "./forecasting-svg.js";
import {GroupSvg} from "./group-svg.js";
import {HarriIconSvg} from "./harri-icon-svg.js";
import {HarriSvg} from "./harri-svg.js";
import {HarriIQFilledSvg} from "./harriIQ-filled-svg.js";
import {HarriIQSvg} from "./harriIQ-svg.js";
import {HistoricalDataSvg} from "./historical-data-svg.js";
import {HrFilledSvg} from "./hr-filled-svg.js";
import {HrSvg} from "./hr-svg.js";
import {IntegrationsFilledSvg} from "./integrations-filled-svg.js";
import {IntegrationsSvg} from "./integrations-svg.js";
import {InterviewQuestionBankSvg} from "./interview-question-bank-svg.js";
import {InterviewsSvg} from "./interviews-svg.js";
import {JobsFilledSvg} from "./jobs-filled-svg.js";
import {JobPostSvg} from "./job-post-svg.js";
import {JobsSvg} from "./jobs-svg.js";
import {LiveScheduleSvg} from "./live-schedule-svg.js";
import {LivewireSvg} from "./livewire-svg.js";
import {LogbookSvg} from "./logbook-svg.js";
import {MyPinboardSvg} from "./my-pinboard-svg.js";
import {MySpotIqSvg} from "./my-spot-iq-svg.js";
import {NoDataSvg} from "./no-data-svg.js";
import {NotesSvg} from "./notes-svg.js";
import {OnboardingJourneyFilledSvg} from "./onboarding-journey-filled-svg.js";
import {OnboardingFilledSvg} from "./onboarding-filled-svg.js";
import {OnboardingSvg} from "./onboarding-svg.js";
import {OnboardingJourneySvg} from "./onboarding-journey-svg.js";
import {PayRunsSvg} from "./pay-runs-svg.js";
import {PaydataSheetSvg} from "./paydata-sheet-svg.js";
import {PmsFilledSvg} from "./pms-filled-svg.js";
import {ProfileMatchingSvg} from "./profile-matching-svg.js";
import {PmsSvg} from "./pms-svg.js";
import {RegularScheduleVariationsSvg} from "./regular-schedule-variations-svg.js";
import {PunchManagementSvg} from "./punch-management-svg.js";
import {RegularScheduleSvg} from "./regular-schedule-svg.js";
import {ScheduleDashSvg} from "./schedule-dash-svg.js";
import {ScheduleSvg} from "./schedule-svg.js";
import {SearchDataSvg} from "./search-data-svg.js";
import {SchedulingSvg} from "./scheduling-svg.js";
import {SchedulingFilledSvg} from "./scheduling-filled-svg.js";
import {ShDashboardsFilledSvg} from "./sh-dashboards-filled-svg.js";
import {ShDashboardsSvg} from "./sh-dashboards-svg.js";
import {ShiftTradeSvg} from "./shift-trade-svg.js";
import {SettingsSvg} from "./settings-svg.js";
import {SicknessSvg} from "./sickness-svg.js";
import {TalentPoolFilledSvg} from "./talent-pool-filled-svg.js";
import {TalentFilledSvg} from "./talent-filled-svg.js";
import {TalentPoolSvg} from "./talent-pool-svg.js";
import {TalentSvg} from "./talent-svg.js";
import {TeamRequestsSvg} from "./team-requests-svg.js";
import {TeamTasksFilledSvg} from "./team-tasks-filled-svg.js";
import {TeamTasksSvg} from "./team-tasks-svg.js";
import {TeamSvg} from "./team-svg.js";
import {TeamliveSvg} from "./teamlive-svg.js";
import {TimeKeepingFilledSvg} from "./time-keeping-filled-svg.js";
import {TimesheetSvg} from "./timesheet-svg.js";
import {TimeKeepingSvg} from "./time-keeping-svg.js";
import {TrainingFilledSvg} from "./training-filled-svg.js";
import {TrainingSvg} from "./training-svg.js";
import {TeamliveFilledSvg} from "./teamlive-filled-svg.js";
import {PositionSvg} from "./position-svg.js";
import {OutlinedAcademySettingsSvg} from "./outlined-academy-settings-svg.js";
import {OutlinedElearningSettingsSvg} from "./outlined-elearning-settings-svg.js";
import {ApprovalsSvg} from "./approvals-svg.js";
import {ApprovalsFilledSvg} from "./approvals-filled-svg.js";
import {AtrFilledSvg} from "./atr-filled-svg.js";
import {AtrSvg} from "./atr-svg.js";
import {AvailabilitySvg} from "./availability-svg.js";
import {BudgetSvg} from "./budget-svg.js";
import {BuildingSvg} from "./building-svg.js";
import {CarriSvg} from "./carri-svg.js";
import {CollapseSvg} from "./collapse-svg.js";
import {CustomDashboardSvg} from "./custom-dashboard-svg.js";
import {CommshubSvg} from "./commshub-svg.js";
import {CorehrSvg} from "./corehr-svg.js";
import {DashboardSvg} from "./dashboard-svg.js";
import {DashboardFilledSvg} from "./dashboard-filled-svg.js";
import {AbsenceSvg} from "./absence-svg.js";
import {AcademySvg} from "./academy-svg.js";
import {AdamSvg} from "./adam-svg.js";
import {ApplicationsSvg} from "./applications-svg.js";
import {DifferentialPaySvg} from "./differential-pay-svg.js";
import {AcademySettingsSvg} from "./academy-settings-svg.js";
import {ElearningSettingsSvg} from "./elearning-settings-svg.js";
import {ReportScheduleSvg} from "./report-schedule-svg.js";
import {RecruitmentHubSvg} from "./recruitment-hub-svg.js";
import {RecruitmentHubFilledSvg} from "./recruitment-hub-filled-svg.js";
import {IndeedCampaignsSvg} from "./indeed-campaigns-svg.js";
import {MyInterviewFilledSvg} from "./my-interview-filled-svg.js";
import {MyInterviewSvg} from "./my-interview-svg.js";
import {HarriEngageFavFilledSvg} from "./harri-engage-fav-filled-svg.js";
import {HarriEngageFavSvg} from "./harri-engage-fav-svg.js";
import {AverageSpendSvg} from "./average-spend-svg.js";
import {LaborCostSvg} from "./labor-cost-svg.js";
import {SalesSvg} from "./sales-svg.js";
import {AnnouncementSvg} from "./announcement-svg.js";
import {NewFeedSvg} from "./new-feed-svg.js";
import {RewardsRecognitionFilledSvg} from "./rewards-recognitions-filled-svg.js";
import {RewardsRecognitionSvg} from "./rewards-recognition-svg.js";
import {SalliSvg} from "./salli-svg.js";
import {AiScreeningCallSvg} from "./ai-screening-call-svg.js";
import {ManagerNotificationSvg} from "./manager-notification-svg.js";
import {FilledManagerNotificationSvg} from "./filled-manager-notification-svg.js";
import {SocialReferralSvg} from "./social-referal-svg.js";
import {FilledSocialReferralSvg} from "./filled-social-referal-svg.js";

const huiSvgModule = angular.module("huiSvg", []);

huiSvgModule.directive('huiSvgAbsence', AbsenceSvg);
huiSvgModule.directive('huiSvgAcademy', AcademySvg);
huiSvgModule.directive('huiSvgAdam', AdamSvg);
huiSvgModule.directive('huiSvgApplications', ApplicationsSvg);
huiSvgModule.directive('huiSvgApprovals', ApprovalsSvg);
huiSvgModule.directive('huiSvgApprovalsFilled', ApprovalsFilledSvg);
huiSvgModule.directive('huiSvgAtrFilled', AtrFilledSvg);
huiSvgModule.directive('huiSvgAtr', AtrSvg);
huiSvgModule.directive('huiSvgAvailability', AvailabilitySvg);
huiSvgModule.directive('huiSvgBudget', BudgetSvg);
huiSvgModule.directive('huiSvgBuilding', BuildingSvg);
huiSvgModule.directive('huiSvgCarri', CarriSvg);
huiSvgModule.directive('huiSvgCollapse', CollapseSvg);
huiSvgModule.directive('huiSvgCustomDashboard', CustomDashboardSvg);
huiSvgModule.directive('huiSvgCommshub', CommshubSvg);
huiSvgModule.directive('huiSvgCorehr', CorehrSvg);
huiSvgModule.directive('huiSvgDashboard', DashboardSvg);
huiSvgModule.directive('huiSvgDashboardFilled', DashboardFilledSvg);
huiSvgModule.directive('huiSvgElearningFilled', ElearningFilledSvg);
huiSvgModule.directive('huiSvgElearning', ElearningSvg);
huiSvgModule.directive('huiSvgEmploymentEligibility', EmploymentEligibilitySvg);
huiSvgModule.directive('huiSvgEntries', EntriesSvg);
huiSvgModule.directive('huiSvgEmployeeConsent', EmployeeConsentSvg);
huiSvgModule.directive('huiSvgExpand', ExpandSvg);
huiSvgModule.directive('huiSvgFeedback', FeedbackSvg);
huiSvgModule.directive('huiSvgGeneralDocs', GeneralDocsSvg);
huiSvgModule.directive('huiSvgFinalOutstanding', FinalOutstandingSvg);
huiSvgModule.directive('huiSvgGfe', GfeSvg);
huiSvgModule.directive('huiSvgForecasting', ForecastingSvg);
huiSvgModule.directive('huiSvgGroup', GroupSvg);
huiSvgModule.directive('huiSvgHarriIcon', HarriIconSvg);
huiSvgModule.directive('huiSvgHarri', HarriSvg);
huiSvgModule.directive('huiSvgHarriIqFilled', HarriIQFilledSvg)
huiSvgModule.directive('huiSvgHarriIq', HarriIQSvg)
huiSvgModule.directive('huiSvgHistoricalData', HistoricalDataSvg);
huiSvgModule.directive('huiSvgHrFilled', HrFilledSvg);
huiSvgModule.directive('huiSvgHr', HrSvg);
huiSvgModule.directive('huiSvgIntegrationsFilled', IntegrationsFilledSvg);
huiSvgModule.directive('huiSvgIntegrations', IntegrationsSvg);
huiSvgModule.directive('huiSvgInterviewQuestionBank', InterviewQuestionBankSvg);
huiSvgModule.directive('huiSvgInterviews', InterviewsSvg);
huiSvgModule.directive('huiSvgJobsFilled', JobsFilledSvg);
huiSvgModule.directive('huiSvgJobPost', JobPostSvg);
huiSvgModule.directive('huiSvgJobs', JobsSvg);
huiSvgModule.directive('huiSvgLiveSchedule', LiveScheduleSvg);
huiSvgModule.directive('huiSvgLivewire', LivewireSvg);
huiSvgModule.directive('huiSvgLogbook', LogbookSvg);
huiSvgModule.directive('huiSvgMyPinboard', MyPinboardSvg);
huiSvgModule.directive('huiSvgMySpotIq', MySpotIqSvg);
huiSvgModule.directive('huiSvgNoData', NoDataSvg);
huiSvgModule.directive('huiSvgNotes', NotesSvg);
huiSvgModule.directive('huiSvgOnboardingJourneyFilled', OnboardingJourneyFilledSvg);
huiSvgModule.directive('huiSvgOnboardingFilled', OnboardingFilledSvg);
huiSvgModule.directive('huiSvgOnboarding', OnboardingSvg);
huiSvgModule.directive('huiSvgOnboardingJourney', OnboardingJourneySvg);
huiSvgModule.directive('huiSvgPayRuns', PayRunsSvg);
huiSvgModule.directive('huiSvgPaydataSheet', PaydataSheetSvg);
huiSvgModule.directive('huiSvgPmsFilled', PmsFilledSvg);
huiSvgModule.directive('huiSvgProfileMatching', ProfileMatchingSvg);
huiSvgModule.directive('huiSvgPms', PmsSvg);
huiSvgModule.directive('huiSvgRegularScheduleVariations', RegularScheduleVariationsSvg);
huiSvgModule.directive('huiSvgPunchManagement', PunchManagementSvg);
huiSvgModule.directive('huiSvgRegularSchedule', RegularScheduleSvg);
huiSvgModule.directive('huiSvgScheduleDash', ScheduleDashSvg);
huiSvgModule.directive('huiSvgSchedule', ScheduleSvg);
huiSvgModule.directive('huiSvgSalli', SalliSvg);
huiSvgModule.directive('huiSvgSearchData', SearchDataSvg);
huiSvgModule.directive('huiSvgScheduling', SchedulingSvg);
huiSvgModule.directive('huiSvgSchedulingFilled', SchedulingFilledSvg);
huiSvgModule.directive('huiSvgShDashboardsFilled', ShDashboardsFilledSvg);
huiSvgModule.directive('huiSvgShDashboards', ShDashboardsSvg);
huiSvgModule.directive('huiSvgShiftTrade', ShiftTradeSvg);
huiSvgModule.directive('huiSvgSettings', SettingsSvg);
huiSvgModule.directive('huiSvgSickness', SicknessSvg);
huiSvgModule.directive('huiSvgTalentPoolFilled', TalentPoolFilledSvg);
huiSvgModule.directive('huiSvgTalentFilled', TalentFilledSvg);
huiSvgModule.directive('huiSvgTalentPool', TalentPoolSvg);
huiSvgModule.directive('huiSvgTalent', TalentSvg);
huiSvgModule.directive('huiSvgTeamRequests', TeamRequestsSvg);
huiSvgModule.directive('huiSvgTeamTasksFilled', TeamTasksFilledSvg);
huiSvgModule.directive('huiSvgTeamTasks', TeamTasksSvg);
huiSvgModule.directive('huiSvgTeam', TeamSvg);
huiSvgModule.directive('huiSvgTeamlive', TeamliveSvg);
huiSvgModule.directive('huiSvgTimeKeepingFilled', TimeKeepingFilledSvg);
huiSvgModule.directive('huiSvgTimesheet', TimesheetSvg);
huiSvgModule.directive('huiSvgTimeKeeping', TimeKeepingSvg);
huiSvgModule.directive('huiSvgTrainingFilled', TrainingFilledSvg);
huiSvgModule.directive('huiSvgTraining', TrainingSvg);
huiSvgModule.directive('huiSvgTeamliveFilled', TeamliveFilledSvg);
huiSvgModule.directive('huiSvgPosition', PositionSvg);
huiSvgModule.directive('huiSvgDifferentialPay', DifferentialPaySvg);
huiSvgModule.directive('huiSvgOutlinedAcademySettings', OutlinedAcademySettingsSvg);
huiSvgModule.directive('huiSvgOutlinedElearningSettings', OutlinedElearningSettingsSvg);
huiSvgModule.directive('huiSvgAcademySettings', AcademySettingsSvg);
huiSvgModule.directive('huiSvgElearningSettings', ElearningSettingsSvg);
huiSvgModule.directive('huiSvgReportSchedule', ReportScheduleSvg);
huiSvgModule.directive('huiSvgRecruitmentHub', RecruitmentHubSvg);
huiSvgModule.directive('huiSvgRecruitmentHubFilled', RecruitmentHubFilledSvg);
huiSvgModule.directive('huiSvgIndeedCampaigns', IndeedCampaignsSvg);
huiSvgModule.directive('huiSvgMyInterviewFilled', MyInterviewFilledSvg);
huiSvgModule.directive('huiSvgMyInterview', MyInterviewSvg);
huiSvgModule.directive('huiSvgHarriEngageFavFilled', HarriEngageFavFilledSvg);
huiSvgModule.directive('huiSvgHarriEngageFav', HarriEngageFavSvg);
huiSvgModule.directive('huiSvgAverageSpend', AverageSpendSvg);
huiSvgModule.directive('huiSvgLaborCost', LaborCostSvg);
huiSvgModule.directive('huiSvgSales', SalesSvg);
huiSvgModule.directive('huiSvgAnnouncement', AnnouncementSvg);
huiSvgModule.directive('huiSvgCommsNewsFeed', NewFeedSvg);
huiSvgModule.directive('huiSvgRewardsRecognitionFilled', RewardsRecognitionFilledSvg);
huiSvgModule.directive('huiSvgRewardsRecognition', RewardsRecognitionSvg);
huiSvgModule.directive('huiSvgAiScreeningCall', AiScreeningCallSvg);
huiSvgModule.directive('huiSvgManagerNotification', ManagerNotificationSvg);
huiSvgModule.directive('huiSvgFilledManagerNotification', FilledManagerNotificationSvg);
huiSvgModule.directive('huiSvgSocialReferral', SocialReferralSvg);
huiSvgModule.directive('huiSvgFilledSocialReferral', FilledSocialReferralSvg);

